export const URL_SERVICE = process.env.ENVIRONMENT === 'STG' ? 'https://l60xo7vpwj.execute-api.us-east-1.amazonaws.com/stg/pequenin' :
    process.env.ENVIRONMENT === 'PDN' ? 'https://2blh4fqkq6.execute-api.us-east-1.amazonaws.com/pdn/pequenin' :
        'https://u79iu4uev0.execute-api.us-east-1.amazonaws.com/dev/pequenin';



export const URL_TRANSVERSAL = process.env.ENVIRONMENT === 'STG' ? 'https://u79iu4uev0.execute-api.us-east-1.amazonaws.com/dev/familia' :
    process.env.ENVIRONMENT === 'PDN' ? 'https://2blh4fqkq6.execute-api.us-east-1.amazonaws.com/pdn/familia' :
        'https://u79iu4uev0.execute-api.us-east-1.amazonaws.com/dev/familia';



//WebToCase Variables
export const WebToCaseUrl = process.env.ENVIRONMENT === 'STG' ? 'https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8' :
  process.env.ENVIRONMENT === 'PDN' ? 'https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8' :
    'https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8';
export const ORGID = process.env.ENVIRONMENT !== 'PDN' ? '00D3j0000001yNQ' : '00D3j0000001yNQ';
export const RECORDTYPE = process.env.ENVIRONMENT !== 'PDN' ? '0123j000000X9zrAAC' : '0123j000000X9zrAAC';

export const CLIENT_ID = process.env.ENVIRONMENT !== 'PDN' ? '10prlbiado4ieqmmv31nedlbc' : '4l2ebk4ltfhfu0dnhais1l2qhs';
export const REFRESH_TOKEN = process.env.ENVIRONMENT !== 'PDN' ? 'https://nol-dev.auth.us-east-1.amazoncognito.com/oauth2/token' : 'https://nol-pdn.auth.us-east-1.amazoncognito.com/oauth2/token';

export const MockConst = 'https://api.myjson.com/bins/18rx45';

// Get ip Address
export const GET_IP_ADDRESS = 'https://jsonip.com/';
